import { render, staticRenderFns } from "./receiptTableDetail.vue?vue&type=template&id=235e0e8d"
import script from "./receiptTableDetail.vue?vue&type=script&lang=js"
export * from "./receiptTableDetail.vue?vue&type=script&lang=js"
import style0 from "./receiptTableDetail.vue?vue&type=style&index=0&id=235e0e8d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports